import React from "react";
import DataWizard from "./DataWizard";
import { useTranslation } from "../../i18n/useTranslation";

const DataWizardWrapper = (props) => {
  const t = useTranslation();

  return <DataWizard {...props} t={t} />;
};

export default DataWizardWrapper;
